export default __webpack_public_path__ + "static/wwf-webfont-21585298ab402470daa46b823727efed.woff";